<template>
  <transition name="fade">
    <v-card flat>
      <v-overlay v-if="loader">Cargando </v-overlay>
      <v-form ref="formCupon" @submit="checkForm">
        <v-text-field
          label="Nombre"
          :rules="rules.requerido"
          v-model="nombre"
        ></v-text-field>
        <v-switch v-model="status" label="Estatus"> </v-switch>
        <v-text-field
          label="Costo de Cupón"
          :rules="rules.requerido"
          v-model="costoCupon"
          @keypress="$pgsHelper.onlyNumber($event, costoCupon)"
        ></v-text-field>
        <v-select
          label="Moneda"
          :rules="rules.requerido"
          v-model="monedaCupon"
          :items="tipos_moneda"
          item-value="id"
          item-text="Nombre"
        >
        </v-select>
        <v-text-field
          v-if="false"
          label="Vigencia (Dias)"
          :rules="rules.requerido"
          v-model="vigencia"
          @keypress="$pgsHelper.onlyNumber($event, vigencia)"
        ></v-text-field>

        <div v-if="false">
          <label
            >Cupones disponibles
            <div
              v-if="errors.cantidad"
              class="ui left pointing red basic label"
            >
              {{ errors.cantidad }}
            </div>
          </label>

          <div v-if="cuponesIlimitados" class="ui right labeled input">
            <input
              type="text"
              style="color: #21ba45"
              value="Ilimitado"
              readonly
              placeholder="Limite"
            />
            <a
              href="javascript:void(0);"
              @click="cuponesIlimitados = false"
              class="ui orange tag label"
            >
              Manejar Limite
            </a>
          </div>

          <div v-if="!cuponesIlimitados" class="ui right labeled input">
            <input
              v-model="cantidad"
              @keypress="$pgsHelper.onlyNumber($event, cantidad)"
              type="text"
              placeholder="Cantidad de cupones a usar"
            />
            <a
              href="javascript:void(0);"
              @click="cuponesIlimitados = true"
              class="ui green tag label"
            >
              Volver Ilimitado
            </a>
          </div>
        </div>

        <v-card>
          <v-card-text>
            <p>Agrega los productos y servicios incluidos en el cupón</p>
            <v-autocomplete
              label="Producto"
              v-model="selectedProd.producto"
              :items="comp_prod.selectProductos"
              item-value="id"
            ></v-autocomplete>
            <v-text-field
              label="Precio Contable USD"
              v-model="selectedProd.PrecioContable"
              @keypress="
                $pgsHelper.onlyNumber($event, selectedProd.PrecioContable)
              "
            ></v-text-field>
            <v-text-field
              label="Precio Agencia USD"
              v-model="selectedProd.PrecioMayorista"
              @keypress="
                $pgsHelper.onlyNumber($event, selectedProd.PrecioMayorista)
              "
            ></v-text-field>
            <v-text-field
              label="Cantidad"
              v-model="selectedProd.cantidad"
              @keypress="$pgsHelper.onlyNumber($event, selectedProd.cantidad)"
            ></v-text-field>

            <v-btn outlined color="primary" @click="addProduct()">
              Agregar
            </v-btn>
          </v-card-text>

          <v-simple-table>
            <thead>
              <tr>
                <th>Producto</th>
                <th>Cantidad</th>
                <th>Precio Contable</th>
                <th>Precio Agencia</th>
                <th>Opciones</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(producto, index) in productos">
                <tr :key="index">
                  <td>{{ producto.Nombre }}</td>
                  <td>{{ producto.CantVenta }}</td>
                  <td>{{ producto.PrcoMayorista }} USD</td>
                  <td>{{ producto.PrcoContable }} USD</td>
                  <td>
                    <v-btn
                      @click="removeProduct(index)"
                      color="red"
                      type="button"
                      icon
                    >
                      <i class="lni lni-trash"></i>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </tbody>
          </v-simple-table>
          <v-card-actions>
            <v-row>
              <v-col md="12" class="text-right">
                <v-btn type="submit" color="success"> Guardar </v-btn>
                <v-btn
                  @click="$emit('toggle', false)"
                  color="error"
                  class="mx-1"
                >
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>

        <!-- end transportacion hotel -->
      </v-form>
    </v-card>
  </transition>
</template>

<style scoped>
.select2-container {
  width: 100% !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
//const $ = require('jquery');
//window.$ = $;

//import axiosCore from 'axios'
//import Select2 from "v-select2-component";
import currencies from "../../../clases/Currencies.js";
export default {
  name: "FormCupones",
  components: {
    /*Select2,*/
  },
  props: ["edit", "dataEdit", "series"],
  data() {
    return {
      tipos_moneda: [],
      monedaCupon: currencies.getCurrencyDefault(),
      limitedMode: true,
      limitProduct: "-MLyebbTVJUkHHD3kkO2",
      nombre: "",
      vigencia: 0,
      cantidad: "",
      status: true,
      cuponesIlimitados: true,
      costoCupon: 0,
      rules: {
        requerido: [(value) => !!value || "El campo es obligatorio"],
      },
      selectedProd: {
        producto: "",
        cantidad: 1,
        PrecioContable: "",
        PrecioMayorista: "",
      },
      mayorista: "",
      productos: [],
      mayoristas: [],
      Id: "",
      errors: {},
      loader: true,
    };
  },
  methods: {
    async getMayoristas() {
      let mayoristas = this.$store.getters.getMayoristas;
      this.mayoristas = mayoristas;
    },
    removeProduct(index) {
      this.productos.splice(index, 1);
    },
    addProduct() {
      if (
        this.selectedProd.producto == "" ||
        this.selectedProd.cantidad <= 0 ||
        this.selectedProd.cantidad == "" ||
        this.selectedProd.PrecioContable < 0 ||
        this.selectedProd.PrecioContable == "" ||
        this.selectedProd.PrecioMayorista < 0 ||
        this.selectedProd.PrecioMayorista == ""
      ) {
        this.$swal({
          allowOutsideClick: false,
          title: "Verifique la información",
          text: "Verifique que el campo producto y cantidad se encuentren correctos",
          icon: "error",
        });
      } else {
        let itemIndex = this.$_.findIndex(this.productos, {
          compId: this.selectedProd.producto,
        });
        if (itemIndex >= 0) {
          this.productos[itemIndex].CantVenta += parseInt(
            this.selectedProd.cantidad
          );
        } else {
          let producto = this.getProductoById(this.selectedProd.producto);

          this.productos.push({
            compId: producto.compId,
            Nombre: producto.Nombre,
            Id: producto.id,
            CantVenta: parseInt(this.selectedProd.cantidad),
            MndaContable: "USD",
            MndaMayorista: "USD",
            Tipo: producto.Tipo,
            Origen: producto.Origen,
            PrcoContable: parseFloat(this.selectedProd.PrecioContable),
            PrcoMayorista: parseFloat(this.selectedProd.PrecioMayorista),
          });
        }
      }
    },
    async getTiposMoneda() {
      this.tipos_moneda = currencies.getCurrencies();
      this.$pgsHelper.log(this.tipos_moneda);
    },
    getProductoById(code) {
      let prod = this.comp_prod.productos;
      let itemIndex = this.$_.findIndex(prod, { compId: code });
      if (itemIndex >= 0) {
        return this.$pgsHelper.cloneObj(prod[itemIndex]);
      }

      return false;
    },
    checkForm: function (e) {
      e.preventDefault();
      let valid = true;
      if (this.$refs.formCupon.validate()) {
        if (valid) {
          let doAction = "CREATE";
          if (this.edit) {
            doAction = "EDIT";
          }
          this.$emit("successData", this.$data, doAction);
        }
      }
    },
  },
  computed: {
    comp_prod() {
      let newProductos = [];
      let prod = this.$store.getters.getProductos;
      let origenes = this.$store.getters.getOrigenes;

      prod.forEach((producto) => {
        let matchCount = 0;
        origenes.forEach((origen, index) => {
          let origenesNames = this.$store.getters.getCentrosConsumo;
          let itemIndex = this.$_.findIndex(origenesNames, {
            id: origen.Origen,
          });
          origen.nombreOrigen = origenesNames[itemIndex]?.Nombre;
          let OrProd = Object.entries(origen.Productos);
          let productMatch = "";
          OrProd.forEach((oProducto) => {
            if (oProducto[0] == producto.id) {
              productMatch = oProducto;
              matchCount++;
              //this.$pgsHelper.log(oProducto[1]);
              /* let pro = producto;
                  let idCompuesto = pro.id+'_'+origen.Origen;
                  pro.Existencia = oProducto[1].Stock;
                  pro.compId = idCompuesto;
                  newProductos.push({id:idCompuesto ,Existencia: oProducto[1].Stock,...producto});*/
            }
          });
          if (productMatch != "") {
            let idCompuesto = producto.id + "_" + origen.Origen;
            let existencia = productMatch[1].Stock;

            newProductos.push({
              compId: idCompuesto,
              Origen: origen.Origen,
              NewPrice: productMatch[1].PV,
              NombreOrigen: origen.nombreOrigen,
              ExistenciaOrigen: existencia,
              ...producto,
            });
          }
        });

        if (matchCount == 0) {
          let idCompuesto = producto.id;
          newProductos.push({
            compId: idCompuesto,
            ExistenciaOrigen: 0,
            ...producto,
          });
        }
      });

      newProductos.forEach((element) => {
        element.Existencia = element.ExistenciaOrigen;
        if (element.NewPrice) {
          element.Precio = element.NewPrice;
        }
        element.Moneda = this.$Currencies.getCurrencyDefault();
      });

      let prodComp = [{ id: "", text: "Seleccione un producto" }];
      newProductos.forEach((ele) => {
        let prodData = {
          id: ele.compId,
          text: ele.Origen ? ele.Nombre + "-" + ele.NombreOrigen : ele.Nombre,
        };
        prodComp.push(prodData);
      });
      if (this.limitedMode) {
        prodComp = [];
        newProductos = [];
      }
      let addons = this.$store.getters.getRVACatalogo;
      addons = Object.entries(addons);

      addons.forEach((ele) => {
        if (this.limitedMode) {
          if ("GOLFROUND" == ele[0]) {
            ele[1].compId = ele[1].Codigo;
            let prodData = {
              id: ele[1].Codigo,
              text: ele[1].Origen
                ? ele[1].Nombre + "-" + ele[1].NombreOrigen
                : ele[1].Nombre,
            };

            prodComp.push(prodData);
            newProductos.push(ele[1]);
          }
        } else {
          ele[1].compId = ele[1].id;
          let prodData = {
            id: ele[1].Codigo,
            text: ele[1].Origen
              ? ele[1].Nombre + "-" + ele[1].NombreOrigen
              : ele[1].Nombre,
          };

          prodComp.push(prodData);
          newProductos.push(ele[1]);
        }
      });
      return { productos: newProductos, selectProductos: prodComp };
    },
  },
  watch: {},
  beforeMount: function () {
    this.loader = true;
    this.getMayoristas();
    this.getTiposMoneda();
  },
  mounted() {
    this.loader = false;
    if (this.edit) {
      this.Id = this.dataEdit.id;
      this.monedaCupon = this.dataEdit.Moneda;
      this.nombre = this.dataEdit.Nombre;
      this.costoCupon = this.dataEdit.Precio ? this.dataEdit.Precio : 0;
      this.status = this.dataEdit.Activo;
      this.cuponesIlimitados = this.dataEdit.UsosVenta ? false : true;
      this.cantidad = this.dataEdit.UsosVenta ? this.dataEdit.UsosVenta : "";
      let cuponMayorista = Object.entries(this.dataEdit.Mayoristas);
      this.mayorista = cuponMayorista[0][0];
      let prodCupon = [];
      this.dataEdit.Catalogo.forEach((ele) => {
        let id_Compuesto = ele.Origen ? ele.Id + "_" + ele.Origen : ele.Id;
        ele.compId = id_Compuesto;
        let producto = this.$pgsHelper.getById(
          this.comp_prod.productos,
          "compId",
          id_Compuesto
        );
        ele.Nombre = producto.Origen
          ? producto.Nombre + " - " + producto.NombreOrigen
          : producto.Nombre;
        this.$pgsHelper.log(ele);
        ele.CantVenta = parseInt(ele.CantVenta);
        prodCupon.push(ele);
      });
      this.productos = prodCupon;
    }
  },
};
</script>
